//财务
import financeHome from '@/components/jm/finance/home.vue'
//商品类型分成管理
import typeHome from '@/components/jm/finance/type/home.vue'
import typeList from '@/components/jm/finance/type/list.vue'
import typeList2 from '@/components/jm/finance/type/list2.vue'
import typeAdd from '@/components/jm/finance/type/add.vue'
import typeUpdate from '@/components/jm/finance/type/update.vue'
//对账统计
import checkingHome from '@/components/jm/finance/checking/home.vue'
import checkingOper from '@/components/jm/finance/checking/oper.vue'
import checkingAlliance from '@/components/jm/finance/checking/alliance.vue'
import checkingAdv from '@/components/jm/finance/checking/adv.vue'
import checkingBaobiaoMonth from '@/components/jm/finance/checking/baobiaoMonth.vue'
//退款信息
import refundHome from '@/components/jm/finance/refund/home.vue'
import refundList from '@/components/jm/finance/refund/list.vue'
import refundDetails from '@/components/jm/finance/refund/details.vue'
export default [{
	path: 'finance',
	name: 'finance',
	component: financeHome,
	children: [{ //商品类型，抽成
		path: 'financeTypeHome',
		name: 'financeTypeHome',
		component: typeHome,
		children: [{
			path: 'list',
			name: 'jm/finance/type/list',
			component: typeList,
			meta: {
				 keepAlive: true // 需要缓存
			}
		},{
			path: 'list2',
			name: 'jm/finance/type/list2',
			component: typeList2,
			meta: {
				 keepAlive: true // 需要缓存
			}
		},  {
			path: 'add',
			name: 'jm/finance/type/add',
			component: typeAdd
		}, {
			path: 'update',
			name: 'jm/finance/type/update',
			component: typeUpdate
		}]
	},{ //对账信息
		path: 'checkingHome',
		name: 'checkingHome',
		component: checkingHome,
		children: [{
			path: 'oper',
			name: 'jm/finance/checking/oper',
			component: checkingOper
		},{
			path: 'alliance',
			name: 'jm/finance/checking/alliance',
			component: checkingAlliance
		},{
			path: 'adv',
			name: 'jm/finance/checking/adv',
			component: checkingAdv
		},{
			path: 'biaobiaoMonth',
			name: 'jm/finance/checking/biaobiaoMonth',
			component: checkingBaobiaoMonth
		}]
	},{ //对账信息
		path: 'refundHome',
		name: 'refundHome',
		component: refundHome,
		children: [{
			path: 'refundHome',
			name: 'jm/finance/refund/list',
			component: refundList,
			meta: {
				 keepAlive: true // 需要缓存
			}
		},{
			path: 'refundHome',
			name: 'jm/finance/refund/details',
			component: refundDetails
		}]
	}]
}]



// WEBPACK FOOTER //
// ./src/router/jm/finance/finance.js